import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { useState } from "react";
import InputText from "../../shared/input/new/InputText";
import InputSelect from "../../shared/input/new/InputSelect";
import InputPhoneNew from "../../shared/input/new/InputPhoneNew";
import { adminAraclarAracUpdate } from "../../../features/admin2/admin2Slice";
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions";
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect";
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect";
import InputDate from "../../shared/input/new/InputDate";
import moment from "moment";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: 550px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      .col {
        display: flex;
        flex-direction: column;
        .row {
          margin-block: 10px;
        }
      }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const AdminAracGuncelleModal = () => {

  const aracTuruData = [
    {
      id:1,
      text:"10 Teker Kamyon"
    },
    {
      id:2,
      text:"Kırkayak"
    },
    {
      id:3,
      text:"6 Teker Kamyon"
    },
    {
      id:4,
      text:"Kamyonet"
    },
    {
      id:5,
      text:"Çekici"
    },
    {
      id:6,
      text:"Römork"
    },
    {
      id:7,
      text:"Y.Römork"
    }
  ]

  const statusData = [
    {
      id:1,
      text:"Aktif",
      type:"aktif"
    },
    {
      id:2,
      text:"Pasif",
      type:"pasif"
    }
  ]

  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  const [selectAracTuru, setSelectAracTuru] = useState(null);
  const [selectCaseType, setSelectCaseType] = useState(null)
  const [initialCaseType, setInitialCaseType] = useState(null)

  const [statusValue, setStatusValue] = useState(selectAdminArac?.isBelgeActive === false ? "Pasif" : "Aktif")
  const [data, setData] = useState(selectAdminArac)
  const [phoneValue, setPhoneValue] = useState(data?.phoneNumber)

  const handleChange = (e) => {
    setData((prev) => ({
      ...prev,
      [e?.target?.name]: e?.target?.value,
    }));
  };

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  useEffect(() => {
    setSelectAracTuru(selectAdminArac?.truckType);
    setSelectCaseType(selectAdminArac?.trailerType)
  }, [selectAdminArac]);
  
  const handleSubmit = () => {
    const addData = {
      ...data,
      aktifPasif: statusValue?.type || statusValue,
      truckType: selectAracTuru?.name || selectAracTuru,
      trailerTypeId: selectCaseType?.id || data?.trailerSubTypeId,
      phoneNumber: phoneValue,
      trafikSigortasıGecerlilikTarihi: moment(data?.trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? data?.trafikSigortasıGecerlilikTarihi : moment(data?.trafikSigortasıGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
      muayeneGecerlilikTarihi: moment(data?.muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? data?.muayeneGecerlilikTarihi : moment(data?.muayeneGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY"),
      kaskoGecerlilikTarihi:  moment(data?.kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY") === "Invalid date" ? data?.kaskoGecerlilikTarihi : moment(data?.kaskoGecerlilikTarihi, "YYYY/MM/DD").format("DD.MM.YYYY")
    };
    dispatch(adminAraclarAracUpdate(addData))
  };

  useEffect(() => {
    if(selectAracTuru?.name === "Çekici" || selectAracTuru === "Çekici"){
      setSelectCaseType(null)
    }
  },[selectAracTuru])


  return (
    <Container>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Güncelle"} />
        <div className="content">
          <div className="col">
          
            <div className="row">
              <InputPhoneNew labelText="Telefon Numarası" data={phoneValue} setData={setPhoneValue} name={"phoneValue"} />
            </div>

            <div className="row">
              <InputText
                data={data.truckPlateNumber || ""}
                setData={(e) => handleChange(e)}
                inputWidth={"100%"}
                labelText="Araç Plakası"
                name={"truckPlateNumber"}
              />
            </div>

            <div className="row">
              <InputSelect
                initialOptions={statusData}
                data={statusValue?.text || statusValue }
                setData={setStatusValue}
                inputWidth={"100%"}
                labelText="Aktif/Pasif"
                name={"statusValue"}
              />
            </div>

            <div className="row">
              <InputNewAracTypeSelect
                initialOptions={AdminAracEkleOptions}
                setInitialCaseType={setInitialCaseType}
                data={selectAracTuru?.name || selectAracTuru}
                setData={setSelectAracTuru}
                inputWidth={"100%"}
                labelText="Araç Türü"
                name={"aracTuru"}
              />
            </div>

            {
              (selectAracTuru?.name !== "Çekici" && selectAracTuru !== "Çekici") &&
              <div className="row">
                <InputCaseTypeSelect 
                  initialOptions={initialCaseType}
                  data={selectCaseType}
                  setData={setSelectCaseType}
                  inputWidth={"100%"}
                  labelText="Kasa Tipi"
                  name={"selectCaseType"}
                />
              </div>
            }

            {
              ((selectAracTuru?.name !== "Y.Römork" && selectAracTuru !== "Y.Römork" ) && (selectAracTuru?.name !== "Römork" && selectAracTuru !== "Römork" )) &&
                <div className="row">
                  <InputDate
                    data={moment(data?.trafikSigortasıGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(data?.trafikSigortasıGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : data?.trafikSigortasıGecerlilikTarihi}
                    setData={(e) => handleChange(e)}
                    inputWidth={"100%"}
                    labelText="Trafik Sigortası Geçerlilik Tarihi"
                    name={"trafikSigortasıGecerlilikTarihi"}
                  />
                </div>
              }
              
              <div className="row">
                <InputDate
                  data={moment(data?.muayeneGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(data?.muayeneGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : data?.muayeneGecerlilikTarihi}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Muayene Geçerlilik Tarihi"
                  name={"muayeneGecerlilikTarihi"}
                />
              </div>
              <div className="row">
                <InputDate
                  data={moment(data?.kaskoGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") !== "Invalid date" ? moment(data?.kaskoGecerlilikTarihi, "DD.MM.YYYY").format("YYYY-MM-DD") : data?.kaskoGecerlilikTarihi}
                  setData={(e) => handleChange(e)}
                  inputWidth={"100%"}
                  labelText="Kasko Geçerlilik Tarihi"
                  name={"kaskoGecerlilikTarihi"}
                />
              </div>

          </div>
        </div>
        <div className="btn">
          <Button
            width="150px"
            handleClick={handleSubmit}
            padding="10px"
            bgColor="transparent"
            color={"#E85446"}
          >
            Güncelle
          </Button>
          <Button
            width="150px"
            handleClick={() => dispatch(showModal(null))}
            padding="10px"
            bgColor="#E85446"
            color={"#fff"}
          >
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AdminAracGuncelleModal;
